exports = module.exports = require("../../../../../../../node_modules/css-loader/lib/css-base.js")(undefined);
// imports


// module
exports.push([module.id, ".pending-span {\n  width: 82px !important;\n  height: 26px !important;\n  font-family: Modern Era;\n  font-size: 12px !important;\n  font-weight: 700 !important;\n  line-height: 18px;\n  letter-spacing: 0px;\n  text-align: center;\n  border-radius: '4px';\n  display: 'flex';\n  justify-content: 'center';\n  align-items: 'center'; }\n", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader!./node_modules/sass-loader/lib/loader.js?sourceMap=true!./node_modules/sass-resources-loader/lib/loader.js??ref--1-oneOf-3-3!./src/components/Dashboard/Panels/Bookings/ViewBookingsPanel/TableCellGenerator/index.scss
// module id = 1082
// module chunks = 1